// ui
import styles from './footer.module.scss';

// next
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { useState } from "react";

export default function Footer() {
    const router = useRouter();
    const { slug } = router.query || {};
    const { isMobile } = useSelector((state) => state.game);
    const [hide, setHide] = useState(true);

    // FAQ 数据数组
    const faqData = [
        {
            title: "How to play games at Gameyeap.com?",
            type: "text",
            isLiTag: true,
            content: [
                "Select any game you are interested on the page",
                "Click the button of \"Play\" on the screen for starting",
                "You can open full screen if you want to experience better",
                "Share the game link to your friends once you are happy to let more people enjoy"
            ]
        },
        {
            title: "What are the most popular games?",
            type: "games", // 标记这是游戏列表，需要特殊处理
            content: [
                "Sprunki Incredibox",
                "Brawl Stars",
                "ASMR Stye Treatment",
                "Survive The Glass Bridge",
                "Puzzle Lab",
                "BlockPuzzle Color Blast",
                "Music Line 3",
                "Make Up Queen R",
                "Tom And Jerry Dress Up",
                "Sprunki Baby Phase 3"
            ]
        },
        {
            title: "What categories do you recommend?",
            type: "text",
            content: [
                "We have hundreds of games in different genres that cater to all kinds of player. Feel free to try amazing music games, puzzle games and block games. If you are a lovely girl, we are happy to prepare special dress up and makeup games for enjoying."
            ]
        }
    ];

    const handleBackHome = (link) => {
        router.push(`/${link}`);
    };

    // 格式化游戏名称为 URL slug
    const formatGameName = (gameName) => {
        return gameName
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '') // 移除特殊字符
            .trim()
            .replace(/\s+/g, '-'); // 将空格替换为连字符
    };

    // 处理游戏点击事件
    const handleGameClick = (gameName) => {
        const formattedName = formatGameName(gameName);
        router.push(`/game/${formattedName}`);
    };

    // 关键字映射
    const keywordRoutes = {
        'music games': '/game/music',
        'puzzle games': '/game/puzzle',
        'block games': '/game/block',
        'girl': '/game/girls',
        'girls': '/game/girls',
        'dress': '/game/dress',
        'makeup games': '/game/makeup'
    };

    // 处理关键字点击事件
    const handleKeywordClick = (keyword) => {
        const route = keywordRoutes[keyword.toLowerCase()];
        if (route) {
            router.push(route);
        }
    };

    // 将文本中的关键字转换为可点击的元素
    const renderTextWithKeywords = (text) => {
        const keywords = Object.keys(keywordRoutes);
        const keywordRegex = new RegExp(`\\b(${keywords.join('|')})\\b`, 'gi');
        
        const parts = text.split(keywordRegex);
        
        return parts.map((part, index) => {
            const lowerPart = part.toLowerCase();
            if (keywords.includes(lowerPart)) {
                return (
                    <a
                        href={`${keywordRoutes[part]}`}
                        key={index}
                        className={styles.keyword_link}
                        onClick={(e) => {
                            e.preventDefault();
                            handleKeywordClick(part);
                        }}
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.footer_remind}>
                <h2 className={`${styles.footer_head} ${styles.footer_tips}`}>
                    Free online games at Gameyeap
                </h2>

                <div className={`${styles.footer_tips}`}>
                    Unleash instant fun at Gameyeap! Dive into a vibrant universe of free online games built for teens. From thrilling adventures to brain-bending block puzzles and lightning-fast arcade action, your next favorite game is just a click away. No downloads, no fuss – just pure, unadulterated gaming excitement.
                </div>

                {!slug && faqData.map((faq, faqIndex) => [
                    <h2 key={`title-${faqIndex}`} style={{width: "100%", fontSize: '1.25rem'}} className={`${styles.faq_title}} ${hide ? styles.hide : ''}`}>
                        {faq.title}
                    </h2>,
                    ...faq.content.map((text, textIndex) => (
                        faq.isLiTag ? (<li
                                key={`content-${faqIndex}-${textIndex}`}
                                className={`${styles.faq_text} ${faq.type === 'games' ? styles.faq_game_link : ''} ${hide ? styles.hide : ''}`}
                                onClick={faq.type === 'games' ? () => handleGameClick(text) : undefined}
                            >
                                {faq.type === 'games'
                                    ? text
                                    : renderTextWithKeywords(text)
                                }
                            </li>) :
                            faq.type === 'games' ? (<a
                                    key={`content-${faqIndex}-${textIndex}`}
                                    href={`/game/${formatGameName(text)}`}
                                    className={`${styles.faq_text} ${faq.type === 'games' ? styles.faq_game_link : ''} ${hide ? styles.hide : ''}`}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleGameClick(text);
                                    }}
                                >
                                    {text}
                                </a>) :
                        (<div
                            key={`content-${faqIndex}-${textIndex}`}
                            className={`${styles.faq_text_no_point} ${styles.faq_text} ${faq.type === 'games' ? styles.faq_game_link : ''} ${hide ? styles.hide : ''}`}
                            onClick={faq.type === 'games' ? () => handleGameClick(text) : undefined}
                        >
                            {faq.type === 'games'
                                ? text
                                : renderTextWithKeywords(text)
                            }
                        </div>)
                    ))
                ])}

                {!slug && (<div style={{width: '100%'}} className={hide ? styles.hide : ''}>
                    We are still trying our best to update more games daily and let you have a great time. Don’t hesitate to share Gameyeap.com to you friend if you like it!
                </div>)}

                {!slug && (<div
                    style={{cursor: "pointer", color: "#1976d2", fontWeight: "600", display: "flex", justifyContent: "center"}}
                    onClick={() => setHide(!hide)}
                >
                    {hide ? 'Show More...' : 'Show Less...'}
                </div>)}
            </div>

            {!isMobile && <div className={`${styles.footer_bottom} ${styles.footer_tips}`}>
                <div className={styles.copyright}>
                    © 2025 Gameyeap.com LLC. All Rights Reserved.
                </div>
                <a 
                    href="/about" 
                    onClick={(e) => {
                        e.preventDefault();
                        handleBackHome("about");
                    }} 
                    className={styles.footer_link}
                >
                    About Us
                </a>
                <a 
                    href="/contact" 
                    onClick={(e) => {
                        e.preventDefault();
                        handleBackHome("contact");
                    }} 
                    className={styles.footer_link}
                >
                    Contact Us
                </a>
                <a 
                    href="/privacy-policy" 
                    onClick={(e) => {
                        e.preventDefault();
                        handleBackHome("privacy-policy");
                    }} 
                    className={[styles.footer_link]}
                >
                    Privacy Policy
                </a>
            </div>}

            { isMobile && <div className={`${styles.footer_bottom} ${styles.footer_tips}`}>
                <div className={styles.copyright}>
                    © 2025 Gameyeap.com LLC. All Rights Reserved.
                </div>
                <div className={styles.flex_row}>
                    <a 
                        href="/about" 
                        onClick={(e) => {
                            e.preventDefault();
                            handleBackHome("about");
                        }} 
                        className={styles.footer_link}
                    >
                        About Us
                    </a>
                    <a 
                        href="/contact" 
                        onClick={(e) => {
                            e.preventDefault();
                            handleBackHome("contact");
                        }} 
                        className={styles.footer_link}
                    >
                        Contact Us
                    </a>
                    <a 
                        href="/privacy-policy" 
                        onClick={(e) => {
                            e.preventDefault();
                            handleBackHome("privacy-policy");
                        }} 
                        className={[styles.footer_link]}
                    >
                        Privacy Policy
                    </a>
                </div>
            </div>}
        </footer>
    );
}
